import { render, staticRenderFns } from "./StubCmp.vue?vue&type=template&id=27d737e2&scoped=true&lang=pug&"
import script from "./StubCmp.vue?vue&type=script&lang=ts&"
export * from "./StubCmp.vue?vue&type=script&lang=ts&"
import style0 from "./StubCmp.vue?vue&type=style&index=0&id=27d737e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d737e2",
  null
  
)

export default component.exports